export default {
  mediaUploadImage: "Bitte wählen Sie eine Bilddatei",
  mediaUploadVideo: "Bitte wählen Sie eine Videodatei",
  mediaUploadEither: "Bitte wählen Sie eine Bild- oder Videodatei",
  mediaUploadMax: "Datei muss kleiner als {{max}} sein",
  mediaUploadSuccess: "{{type}} hochgeladen",
  storageUploadProcessing: "Wird auf dem Server gespeichert...",
  storageUploadPercent: "{{percent}} %",
  storageUploadTooLarge: "Datei ist zu groß. Maximale Größe ist {{max}}.",
  storageUploadFailed: "Datei konnte nicht hochgeladen werden",
  storageUploadFailedNamed: "{{name}} konnte nicht hochgeladen werden",
  storageUploadFileProgress:
    "{{name}} wird hochgeladen ({{current}} von {{total}})",
  mediaUploadButton: "Hochladen",
  imageCrop: {
    title: "Foto zuschneiden",
    confirm: "Foto verwenden",
    cancel: "Überspringen",
    zoom: "Zoom",
    failed: "Dieses Foto konnte nicht zugeschnitten werden. Versuchen Sie ein anderes Bild.",
  },
  receiptUploadAnalyzing: "Wird analysiert...",
  receiptUploadLabel: "Beleg hochladen",
  receiptUploadBeforeVisit:
    "Diese Aktion ist erst nach Beginn der Buchung verfügbar",
  receiptUploadTooLarge: "Datei ist zu groß. Maximale Größe ist {{max}}.",
  receiptUploadUnsupported:
    "Bitte laden Sie ein Bild oder PDF des Belegs hoch.",
  receiptModalTitle: "Beleg hochgeladen",
  receiptModalSubtitle: "Extrahierten Gesamtbetrag prüfen",
  receiptModalExtracted: "Aus Beleg extrahierter Gesamtbetrag:",
  receiptModalConfirmHint:
    "Bitte bestätigen Sie, dass dieser Betrag korrekt ist",
  receiptModalMismatch:
    'Ist dieser Betrag korrekt? Wenn der Gesamtbetrag nicht mit dem Beleg übereinstimmt, wählen Sie „Foto erneut aufnehmen".',
  receiptModalConfirming: "Wird bestätigt...",
  receiptModalYes: "Ja, ist korrekt",
  receiptModalRetake: "Nein, Foto erneut aufnehmen",
  receiptOcrFailureTitle: "Beleg konnte nicht gelesen werden",
  receiptOcrFailureAttemptsRemaining:
    "{{remaining}} von {{max}} Validierungsversuchen verbleibend",
  receiptOcrFailureManualHint:
    "Automatisches Lesen war nicht erfolgreich. Sie können ein anderes Foto hochladen oder den Betrag manuell eingeben.",
  receiptOcrFailureRetry: "Anderes Foto hochladen",
  receiptOcrFailureManualAmount: "Betrag manuell eingeben",
  receiptPreviewAlt: "Belegfoto",
  receiptViewFull: "Belegfoto anzeigen",
  receiptDownload: "Beleg herunterladen",
  receiptDownloadFailed:
    "Beleg konnte nicht heruntergeladen werden. Versuchen Sie es erneut.",
  attachmentViewFull: "Bild anzeigen",
  attachmentDownload: "Herunterladen",
  attachmentDownloadFailed:
    "Datei konnte nicht heruntergeladen werden. Versuchen Sie es erneut.",
  countrySelectSearchPlaceholder: "Land suchen...",
  countrySelectNoResults: "Kein Land gefunden",
  multiSelectPlaceholder: "Optionen auswählen...",
  multiSelectRemoveChip: "{{label}} entfernen",
  receiptManualAmountTitle: "Belegsumme manuell eingeben",
  receiptManualAmountSubtitle:
    "Automatisches Beleglesen war nicht erfolgreich. Geben Sie den auf dem Beleg angezeigten Gesamtbetrag ein.",
  receiptManualAmountLabel: "Belegsumme (EUR)",
  receiptManualAmountPlaceholder: "z. B. 42,50",
  receiptManualAmountInvalid:
    "Geben Sie einen gültigen Betrag größer als null ein",
  receiptManualAmountSubmit: "Summe speichern",
  transactionCustomer: "Kunde:",
  transactionOpenBooking: "Buchung öffnen",
  transactionVisitDate: "Besuch am {{date}}",
  walletMovements: {
    badges: {
      income: "Einnahme",
      expense: "Ausgabe",
      settlement: "Abrechnung",
      refund: "Erstattung",
    },
    checkout_payment: {
      title: "Kundenzahlung",
    },
    restaurant_fee: {
      title: "Restaurant-Provisionsgutschrift",
    },
    refund: {
      title: "Erstattungsanpassung",
    },
    settlement_sent: {
      title: "Abrechnung auf Ihr Bankkonto überwiesen",
      titleWithReference:
        "Abrechnung auf Ihr Bankkonto überwiesen (Ref.: {{reference}})",
    },
    settlement_received: {
      title: "Abrechnung im Wallet erhalten",
      titleWithReference: "Abrechnung im Wallet erhalten (Ref.: {{reference}})",
    },
    host_payout: {
      title: "Gastgeber-Auszahlung",
    },
    host_commission: {
      title: "Provision",
    },
    sales_agent_commission: {
      title: "Vertriebsagenten-Provision",
    },
    internal_fee: {
      title: "Plattformgebühren-Anpassung",
    },
    unknown: {
      title: "Wallet-Bewegung",
    },
  },
  translationAllRequired: "Alle Sprachen erforderlich",
  translationCharCount: "{{current}}/{{max}}",
  translationOverLimit:
    "Eine oder mehrere Sprachen überschreiten das Limit von {{max}} Zeichen. Kürze den Text in den roten Sprachen.",
  mediaTypeImage: "Bild",
  mediaTypeVideo: "Video",
  itemThumbnailAlt: "Artikelbild",
  productItem: {
    imageTooLarge: "Bild zu groß. Maximale Größe ist 10 MB.",
    menuItemCreated: "Menüpunkt erstellt",
    serviceCreated: "Service erstellt",
    menuItemUpdated: "Menüpunkt aktualisiert",
    serviceUpdated: "Service aktualisiert",
    noCategory: "Keine Kategorie",
    titleEditMenu: "Menüpunkt bearbeiten",
    titleEditService: "Service bearbeiten",
    titleAddMenu: "Menüpunkt hinzufügen",
    titleAddService: "Service hinzufügen",
    allTranslationsRequired: "Name ist in jeder Sprache erforderlich",
    descriptionPartial:
      "Beschreibung muss leer sein oder in jeder Sprache übersetzt sein",
    autoTranslateHint:
      "Name ist in jeder Sprache erforderlich; die Beschreibung muss leer oder in jeder Sprache vollständig sein. Füllen Sie mindestens eine Sprache aus und generieren Sie Übersetzungen. Nach einer Umbenennung erneut generieren, um die anderen Sprachen zu aktualisieren.",
    autoTranslateGenerate: "Übersetzungen generieren",
    autoTranslateConfirmTitle: "Fehlende Übersetzungen ergänzen?",
    autoTranslateConfirm:
      "Es werden nur Übersetzungen für leere Sprachen generiert. Vorhandener Text bleibt unverändert.",
    autoTranslateRefreshTitle: "Andere Sprachen aktualisieren?",
    autoTranslateRefreshConfirm:
      "Alle Sprachen haben bereits Text. Die anderen Sprachen werden durch Übersetzungen aus der Ausgangssprache ersetzt.",
    autoTranslateApplied: "Übersetzungen übernommen",
    validPriceRequired: "Bitte geben Sie einen gültigen Preis ein",
    showKioskDiscountLabel: "Als reduziert auf Geräten anzeigen",
    showKioskDiscountHint:
      "Der reduzierte Preis wird auf Geräten angezeigt und ist der Betrag, den Kunden zahlen.",
    undiscountedPriceEuro: "Unreduzierter Preis (€)",
    discountedPriceEuro: "Reduzierter Preis (€)",
    validUndiscountedPriceRequired:
      "Bitte geben Sie einen gültigen unreduzierten Preis ein",
    validDiscountedPriceRequired:
      "Bitte geben Sie einen gültigen reduzierten Preis ein",
    discountedMustBeLower:
      "Reduzierter Preis muss niedriger als der unreduzierte Preis sein",
    photo: "Foto",
    photoHint: "Max. 10 MB",
    addPhoto: "Foto hinzufügen",
    category: "Kategorie",
    priceEuro: "Preis (€)",
    name: "Name",
    description: "Beschreibung",
    placeholderPriceMenu: "12,50",
    placeholderPriceService: "25,00",
    placeholderNameMenu: "Gerichtname",
    placeholderNameService: "Servicename",
    placeholderDescMenu: "Gerichtbeschreibung",
    placeholderDescService: "Servicebeschreibung",
    hintDescMenu: "Optional — Zutaten, Zubereitung usw. beschreiben",
    hintDescService: "Optional — beschreiben Sie, was der Service umfasst",
    previewAlt: "Vorschau",
    saveChanges: "Änderungen speichern",
    addItem: "Artikel hinzufügen",
    addService: "Service hinzufügen",
  },
  productItems: {
    menu: {
      title: "Menü",
      emptyTitle: "Noch keine Menüpunkte",
      emptySubtitle: "Fügen Sie Ihr erstes Gericht zum Menü hinzu",
      addButton: "Artikel hinzufügen",
      deleteSuccess: "Menüpunkt gelöscht",
    },
    service: {
      title: "Angebotene Services",
      emptyTitle: "Noch keine Services",
      emptySubtitle: "Fügen Sie die Services hinzu, die Sie Kunden anbieten",
      addButton: "Service hinzufügen",
      deleteSuccess: "Service gelöscht",
    },
    toastDeleteErrorMenu: "Fehler beim Löschen des Menüpunkts",
    toastDeleteErrorService: "Fehler beim Löschen des Service",
    toastUpdateErrorMenu: "Fehler beim Aktualisieren des Menüpunkts",
    toastUpdateErrorService: "Fehler beim Aktualisieren des Service",
    toastReorderError: "Fehler beim Neuordnen der Artikel",
    confirmDelete: '„{{name}}" löschen?',
    thisItem: "diesen Artikel",
    filterAll: "Alle ({{count}})",
    uncategorized: "Ohne Kategorie ({{count}})",
  },
  transactionsSection: {
    titleDefault: "Transaktionen",
    filters: "Filter",
    dateRange: "Datumsbereich",
    activity: "Aktivität",
    allActivities: "Alle Aktivitäten",
    searchInDescription: "In Beschreibung suchen",
    searchPlaceholder: "Suchen...",
    minAmountEuro: "Mindestbetrag (€)",
    minAmountPlaceholder: "0,00",
    maxAmountEuro: "Höchstbetrag (€)",
    noLimit: "Kein Limit",
    reset: "Zurücksetzen",
    applyFilters: "Filter anwenden",
    credits: "Gutschriften",
    debits: "Belastungen",
    transactionsCountLabel: "Transaktionen",
    loadingTransactions: "Transaktionen werden geladen...",
    emptyTitle: "Keine Transaktionen",
    emptyDescription: "Keine Transaktionen gefunden",
  },
  sortableItem: {
    itemAltFallback: "Artikel",
    hidden: "Ausgeblendet",
    hide: "Ausblenden",
    show: "Anzeigen",
    discounted: "Reduziert",
  },
} as const;
